import React, { Component } from "react";
import PropTypes from "prop-types";

/* Floating buttons */
import MainButton from "./MainButton";
import ChildButton from "./ChildButton";
import Menu from "./Menu";

import {
  PROJECT_TEAMS,
  PROJECT_ACTIVITY,
  PROJECT_LEADERBOARD,
  PROJECT_REWARDS,
  PROJECT_BOOKMARKS,
  TOPIC_CATEGORY,
  TOPIC,
  CHALLENGE,
  PROJECT_USERS
} from "App/Routes";

const propTypes = {
  buttons: PropTypes.array,
  projectId: PropTypes.number,
  language: PropTypes.string
};

export class FloatingButtons extends Component {
  render() {
    return (
      <Menu effect="slidein-spring" method="click" position="br">
        <MainButton />
        {this.props.buttons
          .slice(0)
          .reverse()
          .map(button => {
            switch (button.buttonType) {
              case "bookmarks":
                return (
                  <ChildButton
                    key={button.id}
                    label={button.buttonText}
                    href={PROJECT_BOOKMARKS.format(this.props.projectId)}
                    icon="fa-bookmark"
                  />
                );
              case "rewards":
                return (
                  <ChildButton
                    key={button.id}
                    label={button.buttonText}
                    href={PROJECT_REWARDS.format(this.props.projectId)}
                    icon="fa-gift"
                  />
                );
              case "leaderboard":
                return (
                  <ChildButton
                    key={button.id}
                    label={button.buttonText}
                    href={PROJECT_LEADERBOARD.format(this.props.projectId)}
                    icon="fa-trophy"
                  />
                );
              case "activity":
                return (
                  <ChildButton
                    key={button.id}
                    label={button.buttonText}
                    href={PROJECT_ACTIVITY.format(this.props.projectId)}
                    icon="fa-list-alt"
                  />
                );
              case "web-url":
                return (
                  <ChildButton
                    key={button.id}
                    label={button.buttonText}
                    href={button.objectReference}
                    isExternalLink={true}
                    icon="fa-external-link-alt"
                  />
                );
              case "web-url-session":
                return (
                  <ChildButton
                    key={button.id}
                    label={button.buttonText}
                    href={button.objectReference}
                    isWebUrlSession={true}
                    projectId={this.props.projectId}
                    icon="fa-link"
                  />
                );
              case "challenge-profile":
                return (
                  <ChildButton
                    key={button.id}
                    label={button.buttonText}
                    href={CHALLENGE.format(button.objectReference)}
                    icon="icon-challenge-placeholder"
                  />
                );
              case "topic":
                return (
                  <ChildButton
                    key={button.id}
                    label={button.buttonText}
                    href={TOPIC.format(button.objectReference)}
                    icon="icon-topics"
                  />
                );
              case "topic-category":
                return (
                  <ChildButton
                    key={button.id}
                    label={button.buttonText}
                    href={TOPIC_CATEGORY.format(
                      this.props.projectId,
                      button.objectReference
                    )}
                    icon="fa-layer-group"
                  />
                );
              case "teams":
                return (
                  <ChildButton
                    key={button.id}
                    label={button.buttonText}
                    href={PROJECT_TEAMS.format(this.props.projectId)}
                    icon="fa-users"
                  />
                );
              case "players":
                return (
                  <ChildButton
                    key={button.id}
                    label={button.buttonText}
                    href={PROJECT_USERS.format(this.props.projectId)}
                    icon="fa-user"
                  />
                );
              default:
                return null;
            }
          })}
      </Menu>
    );
  }
}

FloatingButtons.propTypes = propTypes;

export default FloatingButtons;
